module.exports = __webpack_public_path__ + "static/img/formulary.75b0c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/formulary.png
// module id = 671
// module chunks = 1